import request from '../utils/request';

export function getExpressList(param) {
    return request({
        url: '/admin/search-express',
        method: 'GET',
        params:param
    })
}

export function getFirmList() {
    return request({
        url: '/admin/express-firm',
        method: 'GET'
    })
}

export function addExpress(id,data) {
    if(id==null){
        return request({
            url: '/admin/express',
            method: 'POST',
            data:data
        })
    }else {
        return request({
            url: '/admin/express/'+id,
            method: 'PUT',
            data:data
        })
    }
}

export function deleteExpress(id) {
    return request({
        url: '/admin/express/'+id,
        method: 'DELETE'
    })
}